import { render, staticRenderFns } from "./DueDiligenceNew.vue?vue&type=template&id=3140f671&scoped=true"
import script from "./DueDiligenceNew.vue?vue&type=script&lang=js"
export * from "./DueDiligenceNew.vue?vue&type=script&lang=js"
import style0 from "./DueDiligenceNew.vue?vue&type=style&index=0&id=3140f671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3140f671",
  null
  
)

export default component.exports